import { Observable } from 'rxjs/Observable';
import { Campaign2Service } from './../../../services/campaign-2.0/campaign2.service';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-campaign-add-store-group',
  templateUrl: './campaign-add-store-group.component.html',
  styleUrls: ['./campaign-add-store-group.component.scss', '../coupon-setup.scss']
})
export class CampaignAddStoreGroupComponent implements OnInit {
  addedStores: any[] = [];
  groups: any[] = [];
  // Gli stores mi servono per visualizzarli nel componente genitore
  stores: any[] = [];
  // I filtri cosí strutturati sono necessari per ottenere gli store
  filter: {insegna: string[], area: string[], gruppo: string, codici: string[]};

  @Input() selectedStoresId: string[] = [];
  @Input() selectedGroupsId: string[] = [];
  @Output() onAddStores: EventEmitter<any> = new EventEmitter();

  constructor(
    private campaignService: Campaign2Service
  ) { }

  ngOnInit() {
    this.initFilter();
    this.campaignService.listGroupsWithStores().subscribe(res => this.groups = res);
    this.campaignService.getStoresFromFilters(this.filter).subscribe(res => this.stores = res);
  }

  initFilter() {
    this.filter = {
      insegna: [],
      area: [],
      gruppo: '',
      codici: []
    };
  }

  addStoresFromGroups() {
    if (this.selectedGroupsId.length == 0) {
      this.onAddStores.emit({addedStoresId: this.selectedStoresId, addedStores: this.addedStores});
      return;
    }
    let observablesArray = this.campaignService.listStoresInGroup(this.selectedGroupsId);

    Observable.zip(observablesArray).subscribe(
      groupStores => {
        this.selectedStoresId = [];
        if (this.addedStores.length > 0) {
          this.addedStores = this.deduplicate([].concat(...groupStores));
          this.addedStores.forEach(store => this.selectedStoresId.push(store.id.toString()));
        } else {
          groupStores.forEach(gs => gs.map(store => this.selectedStoresId.push(store.id.toString())));
          this.addedStores = groupStores[0];
        }
        this.onAddStores.emit({
          addedStoresId: this.selectedStoresId,
          addedStores: this.addedStores,
          selectedGroupsId: this.selectedGroupsId
        });
      }
    );
  }

  deduplicate(array) {
    array = array.filter((element, index) => {
      return (array.findIndex(el => el.code == element.code) == index);
    });
    return array;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/campaign-add-store-group/campaign-add-store-group.component.ts